import type { PetPreferences } from '@rover/types/src/PetPreferences';

export default function getDogCareEnabled(petPreferences: PetPreferences): boolean {
  return Boolean(
    petPreferences.smallDogs ||
      petPreferences.mediumDogs ||
      petPreferences.largeDogs ||
      petPreferences.giantDogs ||
      petPreferences.puppies
  );
}
